export function getJobOffers() {
  return fetch(
    'https://public.cells.es/employment-office-services/position/enabled/',
  ).then((data) => data.json());
}
